import { render } from "./DescriptionEditorComponent.vue?vue&type=template&id=4161c278&scoped=true&ts=true"
import script from "./DescriptionEditorComponent.vue?vue&type=script&lang=ts"
export * from "./DescriptionEditorComponent.vue?vue&type=script&lang=ts"

import "./DescriptionEditorComponent.vue?vue&type=style&index=0&id=4161c278&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4161c278"]])

export default __exports__